import { render } from "./BibleFinder.vue?vue&type=template&id=77899080&scoped=true"
import script from "./BibleFinder.vue?vue&type=script&lang=js"
export * from "./BibleFinder.vue?vue&type=script&lang=js"

import "./BibleFinder.vue?vue&type=style&index=0&id=77899080&scoped=true&lang=css"

import exportComponent from "C:\\git\\js\\bible_finder_ui_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77899080"]])

export default __exports__